import { PatientIntakeRegistationStatus } from '@nkr/enums/patient-intake-referral-status';
import { IPatientIntakeListItem } from '@nkr/models/patient-intake';
import { ICellRendererParams } from 'ag-grid-community';
import { ReactNode } from 'react';
import { Label } from 'react-bootstrap';

const RegistrationStatusLabel = (params: ICellRendererParams & { isAdmin: boolean }) => {
    let data = params.data as IPatientIntakeListItem
    let style = 'default';
    let extra: ReactNode = null;

    switch (data.registrationStatusId) {
        case PatientIntakeRegistationStatus.PendingScreening: style = 'warning'; break;
        case PatientIntakeRegistationStatus.SelectCenter: style = 'info'; break;
        case PatientIntakeRegistationStatus.CompleteLabTests: style = 'primary'; break;
        case PatientIntakeRegistationStatus.SentToCenter:
            style = 'success';

            if (params.isAdmin) {
                extra = <><br /><span>({data.centerName})</span></>;
            }

            break;
        case PatientIntakeRegistationStatus.IfPassCandidate: style = 'info'; break;
        case PatientIntakeRegistationStatus.RuledOut: style = 'danger'; break;
    }

    return <Label bsStyle={style}>{data.registrationStatus} {extra}</Label>;
};

export default RegistrationStatusLabel;